import React from 'react';
import { Grid, useTheme } from '@material-ui/core';
import MaterialTable from 'material-table';
import { useAppContext } from 'hooks/useAppContext';
import Equipment from 'classes/Equipment';
import { getEquipment } from 'utils/EquipmentUtils';
import withAppStylesGrid from 'HOCs/withAppStyles';
import SkeletonGrid from 'components/Shared/SkeletonGrid';


function EquipmentDataTable ({customFilter}) {
    const title = "Equipment";
    const theme = useTheme();
    const { selectedProject } = useAppContext();
    const columns = Equipment.columns;
  
    const WrappedGrid = withAppStylesGrid(MaterialTable, { projectID: selectedProject, getRecords: getEquipment, theme, defaultFilters: { projectId: selectedProject, ...customFilter } })
    
  
    return (
      selectedProject && theme ?
        <>
          <Grid container>
            <Grid item xs={12}>
              <WrappedGrid
                columns={columns}
                title={title}
                options={{
                  pageSize: 15,
                  pageSizeOptions: [15, 20, 25],
                  padding: 'dense'
                }}
              />
            </Grid>
           
          </Grid>
        </>
        : <SkeletonGrid title={title} />
    )
}

export default EquipmentDataTable;